<template>
  <AppLayout>
    <transition name="slide">
      <MainNav v-show="isNavVisible" />
    </transition>
    <div
      id="app-container"
      :style="style"
      :data-e2e="AppCypressAttribute.views.LAYOUT_APP_CONTAINER"
    >
      <AppBanner />
      <ExitingEstateSkeleton v-if="isExitingEstate" />
      <router-view :key="$route.query?.refresh" v-else />
      <AppFooter />
      <ClaraForPlannersBubble v-if="canAccessClaraForPlanners" />
    </div>
  </AppLayout>
</template>

<script>
import MainNav from '/@/modules/core/nav/components/MainNav.vue';
import AppBanner from '/@/modules/core/app/components/AppBanner.vue';
import AppFooter from '/@/modules/core/app/components/AppFooter.vue';
import DocumentUIService from '/@/modules/core/app/services/DocumentUIService';
import { PredefinedService } from '/@/modules/predefined/services/PredefinedService';
import { getters } from '/@/modules/core/app/helpers/store';
import ExitingEstateSkeleton from '/@/modules/core/ui/components/ExitingEstateSkeleton.vue';
import { DetectAuthSessionMismatchMixin } from '@/modules/auth/mixins/DetectAuthSessionMismatchMixin';
import AppLayout from '@/modules/core/app/components/presentational/AppLayout.vue';
import { NavToggleMixin } from '@/modules/core/nav/mixins/NavToggleMixin';
import { AppCypressAttribute } from '@/modules/core/app/constants/AppCypressAttribute';
import ClaraForPlannersBubble from '@/modules/ai/components/stateful/clara-for-planners/ClaraForPlannersBubble.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'Layout',
  mixins: [DetectAuthSessionMismatchMixin, NavToggleMixin],
  components: {
    AppLayout,
    ExitingEstateSkeleton,
    MainNav,
    AppBanner,
    AppFooter,
    ClaraForPlannersBubble
  },
  static: {
    AppCypressAttribute
  },
  async beforeRouteEnter(to, from, next) {
    await PredefinedService.onInit();
    DocumentUIService.removeAppLoader();
    next();
  },
  computed: {
    isExitingEstate() {
      return getters.ui.getIsExitingEstate();
    },
    canAccessClaraForPlanners() {
      const user = getters.auth.getUser();

      return !!user?.permission?.canAccessClaraForPlanners && !!user?.hasCurrentEstate;
    }
  }
};
</script>
